import {
  GET_ACCESSIBLE_INTERACTIONS,
  GET_ACTIVE_FILTER,
  RESET_ACCESSIBLE_INTERACTIONS_DATA
} from './accessible-action-types'
import {
  RESET_ACCESSIBLE_INTERACTIONS,
  SET_ACCESSIBLE_INTERACTIONS,
  SET_ACTIVE_FILTER
} from './accessible-mutation-types'
import * as axios from 'axios'
import * as actionTypes from '../../action-types'
import moment from 'moment-es6'

const state = {
  interactions: [],
  activeFilter: 0
}

const mutations = {
  [SET_ACCESSIBLE_INTERACTIONS] (state, interactionPayload) {
    state.interactions = interactionPayload.map((item) => {
      if (item.interactionType === 'EXEMPTION') {
        const title = item.myGroupId ? ('GROUP ' + item.interactionType) : item.interactionType
        return {
          id: item.id,
          type: title,
          dateRange: moment(item.exemption.startDate).format('DD/MM/YYYY') + ' - ' + moment(item.exemption.endDate).format('DD/MM/YYYY'),
          description: item.exemption.exemptionReason.description,
          status: item.exemption.creationDate ? 'Created: ' + moment(item.exemption.creationDate).format('DD/MM/YYYY HH:mm') : ''
        }
      } else if (item.interactionType === 'INTERVENTION') {
        const title = item.myGroupId ? ('GROUP ' + item.interactionType) : item.interactionType
        return {
          id: item.id,
          type: title,
          date: moment(item.intervention.dateOfCommunication.substring(0, 10)).format('DD/MM/YYYY'),
          description: item.intervention.category.description,
          status: item.intervention.status,
          interventionDescription: item.intervention.description,
          targetDate: moment(item.intervention.actionTargetDate).format('DD/MM/YYYY'),
          referral: item.intervention.interventionReferee,
          referrals: item.intervention.interventionComments,
          myGroupId: item.myGroupId
        }
      } else if (item.interactionType === 'ALERT') {
        return {
          id: item.id,
          type: item.interactionType,
          date: moment(item.studentAlert.alertDate).format('DD/MM/YYYY'),
          description: item.studentAlert.alert.name,
          status: ''
        }
      }
    })
  },
  [SET_ACTIVE_FILTER] (state, filter) {
    state.activeFilter = filter
  },
  [RESET_ACCESSIBLE_INTERACTIONS] (state) {
    state.interactions = []
    state.activeFilter = 0
  }
}

const fetchStudentInteractions = function (rootState, studentId, actionData) {
  return axios({
    url: `${rootState.config.baseUrl}:${rootState.config.port}/core/interaction/get/student/${studentId}`,
    method: 'get',
    headers: {
      'Authorization': rootState.profile.loginToken
    },
    actionData
  })
}

const actions = {
  [GET_ACCESSIBLE_INTERACTIONS] ({rootState, commit}, studentId) {
    const actionData = { action: actionTypes.REPLACE_STUDENT_INTERACTIONS, data: studentId }
    fetchStudentInteractions(rootState, studentId, actionData)
      .then((res) => {
        commit(SET_ACCESSIBLE_INTERACTIONS, res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  },
  [GET_ACTIVE_FILTER] ({rootState, commit}, filter) {
    commit(SET_ACTIVE_FILTER, filter)
  },
  [RESET_ACCESSIBLE_INTERACTIONS_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_INTERACTIONS)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleStudentInteractions.js